<section class="ticker">
  <div class="ticker-container">
    <div class="ticker-item-container">
      <div class="ticker-item" *ngFor="let i of [].constructor(2)">
        <div>Абакан</div>
        <div>Альметьевск</div>
        <div>Анапа</div>
        <div>Архангельск</div>
        <div>Астрахань</div>
        <div>Баку</div>
        <div>Барнаул</div>
        <div>Барселона</div>
        <div>Владивосток</div>
        <div>Великий Новгород</div>
        <div>Витебск</div>
        <div>Владимир</div>
        <div>Волгоград</div>
        <div>Волгодонск</div>
        <div>Геленджик</div>
        <div>Гомель</div>
        <div>Горячий ключ</div>
        <div>Евпатория</div>
        <div>Екатеринбург</div>
        <div>Ереван</div>
        <div>Железногорск</div>
        <div>Завидово</div>
        <div>Зеленоградск</div>
        <div>Иркутск</div>
        <div>Йошкар-Ола</div>
        <div>Калининград</div>
        <div>Каспийск</div>
        <div>Кемерово</div>
        <div>Красногорск</div>
        <div>Краснознаменск</div>
        <div>Красноярск</div>
      </div>
    </div>
    <div class="ticker-item-container">
      <div class="ticker-item" *ngFor="let i of [].constructor(2)">
        <div>Лимассол</div>
        <div>Магнитогорск</div>
        <div>Мадрид</div>
        <div>Майкоп</div>
        <div>Махачкала</div>
        <div>Минск</div>
        <div>Могилев</div>
        <div>Набережные Челны</div>
        <div>Нальчик</div>
        <div>Новокузнецк</div>
        <div>Новополоцк</div>
        <div>Оренбург</div>
        <div>Орша</div>
        <div>Пушкин</div>
        <div>Рим</div>
        <div>Ростов-на-Дону</div>
        <div>Рыбинск</div>
        <div>Санкт-Петербург</div>
        <div>Самара</div>
        <div>Севастополь</div>
        <div>Смоленск</div>
        <div>Сосновый Бор</div>
        <div>Сочи</div>
        <div>Старый Оскол</div>
        <div>Суздаль</div>
        <div>Тамбов</div>
        <div>Тараз</div>
        <div>Тбилиси</div>
        <div>Тверь</div>
        <div>Тюмень</div>
        <div>Уфа</div>
        <div>Харьков</div>
        <div>Чебоксары</div>
        <div>Ярославль</div>
        <div>Ялта</div>
      </div>
    </div>
  </div>
</section>
